import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { userSessionHeartbeat } from '../../../actions/currentUserActions'
import { HashLink as Link } from 'react-router-hash-link'

// staticContext is stripped out. It's included by withRouter and causes a React warning
const LgyLink = ({ userSessionHeartbeat, staticContext, ...otherProps }) =>
  <Link smooth onClick={userSessionHeartbeat} {...otherProps} />

const mapDispatchToProps = (dispatch) => bindActionCreators({
  userSessionHeartbeat
}, dispatch)

// LgyLink needs withRouter so that the NavLink child can get the right location props
export default withRouter(connect(undefined, mapDispatchToProps)(LgyLink))
